import axiosInstance from 'services/axiosConfig';
import { handleErrors } from 'actions/errors';
import { BASE_JWT_URL } from 'constants/environmentVariables';
import {
	setAccountData,
	currentAccountIdSelector,
	setAccountDataLoading,
	setUserDetailsLoading,
	setAccounts,
	setAccountsPagination
} from 'reducers/userAuthSlice';
import { addSnackbarAlerts } from 'reducers/globalSlice';
import { t } from 'i18next';

// -- Deprecated on 10/13/2022 --
// export const fetchAccountSettings = () => async (dispatch, getState) => {
// 	const currentAccountId = currentAccountIdSelector(getState());
// 	const url = `${BASE_JWT_URL}/account/${currentAccountId}/settings`;
// 	try {
// 		const response = await axiosInstance.get(url);
// 		return response.data.data;
// 	} catch (errors) {
// 		handleErrors({ errors, dispatch });
// 		return errors;
// 	}
// };

export const updateAccountSettings = payload => async (dispatch, getState) => {
	const currentAccountId = currentAccountIdSelector(getState());
	const url = `${BASE_JWT_URL}/v1/accounts/${currentAccountId}/settings`;
	try {
		const response = await axiosInstance.put(url, payload);
		dispatch(
			addSnackbarAlerts([
				{
					type: 'success',
					message: t('Settings Successfully Updated')
				}
			])
		);
		return response.data.data;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
		return error;
	}
};

export const fetchAccounts = page => async dispatch => {
	dispatch(setUserDetailsLoading(true));
	try {
		const url = `${BASE_JWT_URL}/v1/accounts?appends[]=subscription_status&order_by=account_name&order=asc&page=${page}&appends[]=expiring_soon&appends[]=owner`;
		const response = await axiosInstance.get(url);
		dispatch(setAccounts(response.data.data));
		dispatch(setAccountsPagination(response.data?.meta?.page));
		dispatch(setUserDetailsLoading(false));
		return response.data.data;
	} catch (error) {
		dispatch(setUserDetailsLoading(false));
		handleErrors({ errors: error, dispatch });
	}
};

export const fetchAccountData = () => async (dispatch, getState) => {
	const currentAccountId = currentAccountIdSelector(getState());
	dispatch(setAccountDataLoading(true));
	try {
		const url = `${BASE_JWT_URL}/v1/accounts/${currentAccountId}?appends[]=subscription_status&appends[]=features&appends[]=expiring_soon&appends[]=tokens`;
		const response = await axiosInstance.get(url);
		dispatch(setAccountData(response.data.data));
		dispatch(setAccountDataLoading(false));
		return response.data.data;
	} catch (error) {
		dispatch(setAccountDataLoading(false));
		handleErrors({ errors: error, dispatch });
	}
};
